var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[_vm._v("\n        404\n        "),_c('br'),_vm._v("\n        page is not found! :(\n    ")])])}]

export { render, staticRenderFns }